const actions = {
  SET_STATE: 'blog/SET_STATE',
  SET_ERROR_STATE: 'blog/SET_ERROR_STATE',
  EDIT_DATA: 'blog/EDIT_DATA',
  REMOVE_DATA: 'blog/REMOVE_DATA',
  SHOW_CREATE: 'blog/SHOW_CREATE',
  HIDE_CREATE: 'blog/HIDE_CREATE',
  SHOW_UPDATE: 'blog/SHOW_UPDATE',
  HIDE_UPDATE: 'blog/HIDE_UPDATE',
  SHOW_DELETE: 'blog/SHOW_DELETE',
  HIDE_DELETE: 'blog/HIDE_DELETE',

  LOAD_ALL: 'blog/LOAD_ALL',
  CREATE: 'blog/CREATE',
  UPDATE: 'blog/UPDATE',
  REMOVE: 'blog/REMOVE',
}

export default actions
